<template>
  <w-multiple-tree-selection-filter
    ref="multipleTreeSelection"
    :value="value"
    :items="categoryItems"
    :items-pending="categories_pending"
    :label="label"
    item-text="data.label"
    item-children="data.children"
    item-value="id"
    :disabled="disabled"
    :filter-options="hasFilterOption ? filterOptions : []"
    :filter-option-value="filterOptionValue"
    :option-search-key="categoryOptionSearchKey"
    :option-select-disabled="!moreThanOneAttributesSelected"
    :select-parents="selectParents"
    :sort-items="false"
    @input="$emit('input', $event)"
  />
</template>

<script>
/** MIXINS **/
import filterHierarchyStructureMixin from '@/mixins/filter-hierarchy-structure-mixin';
import dynamicData from '@/mixins/api_data/dynamic-data-mixin';
// components
import WorkAutocomplete from '@/components/global_components/forms/WorkAutocomplete';
//helpers
import isEqual from 'lodash/isEqual';
import i18n from '@/language/i18n';
import { sortItemsModule } from '@/mixins/component/sorted-items-mixin';

export default {
  name: 'WorkCategoryTreeFilter',
  props: {
    ...WorkAutocomplete.props,
    params: { type: Object, default: () => {} },
    filterName: { type: String, default: 'categories' },
    path: { type: String, default: 'productcategories/treehierarchy' },
    categoryOptionSearchKey: { type: String, default: 'categoryRelation' },
    categoryTableFilters: { type: Object, default: undefined },
    hasFilterOption: { type: Boolean, default: true },
    selectParents: { type: Boolean, default: false },
    label: { type: String, default: i18n.t('Common.categories') },
    additionalCategories: { type: Array, default: () => [] },
  },
  data() {
    return {
      internalParams: undefined,
    };
  },
  mixins: [
    dynamicData(
      'categories',
      (self) => self.path,
      (response) => response.data.data,
      (self) => self.internalParams
    ),
    filterHierarchyStructureMixin(
      (self) => self.filterName,
      (self) => self.categoryOptionSearchKey,
      undefined,
      (self) => self.categoryTableFilters ?? undefined
    ),
  ],
  computed: {
    sortedItems() {
      return sortItemsModule.getSortedItems(
        this.$props,
        this.categories?.children ?? []
      );
    },
    categoryItems() {
      let categories = [
        ...(this.additionalCategories ?? []),
        ...(this.sortedItems ?? []),
      ];
      return categories;
    },
  },
  watch: {
    params: {
      handler() {
        if (
          !isEqual(this.params, this.internalParams) &&
          !this.categories_pending
        ) {
          this.internalParams = this.params;
        }
      },
      immediate: true,
    },
    internalParams: {
      async handler() {
        await this._categories_load();
        this.$refs.multipleTreeSelection?.setRemainingValues(this.value);
      },
    },
  },
};
</script>
